import { type HTMLAttributes, type ReactNode } from "react";
import { cn } from "./utils/cn";

export type PillVariant = "neutral" | "accent" | "signal" | "success" | "warning" | "error";

export interface PillProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: PillVariant;
  children?: ReactNode;
}

export const Pill = ({ variant = "neutral", className, children, ...rest }: PillProps) => (
  <span
    className={cn("hui-pill", variant !== "neutral" && `hui-pill--${variant}`, className)}
    {...rest}
  >
    {children}
  </span>
);
